import { render, staticRenderFns } from "./User.vue?vue&type=template&id=67e3d76c&scoped=true&"
import script from "./User.vue?vue&type=script&lang=js&"
export * from "./User.vue?vue&type=script&lang=js&"
import style0 from "./User.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"
import style1 from "./User.vue?vue&type=style&index=1&id=67e3d76c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e3d76c",
  null
  
)

export default component.exports